export default {
  insurances: [],
  isInsuranceExpired: false,
};
